import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import { encryptText } from './utils/burnCrypto'
import { createBurnMessage } from './utils/burnMessageStore'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const BurnMessageCreate = () => {
  useDocumentMeta({
    title: 'Enviar Texto Temporário (Lido Uma Única Vez)  jarder.dev',
    description:
      'Crie um link de texto secreto que só pode ser aberto uma vez  ' +
      'depois disso, desaparece para sempre. Criptografado no seu ' +
      'navegador, grátis.',
  })

  const [text, setText] = useState('')
  const [link, setLink] = useState('')
  const [status, setStatus] = useState('idle')
  const [copied, setCopied] = useState(false)

  const generate = async () => {
    if (!text.trim()) return
    setStatus('loading')
    try {
      const { ciphertext, iv, keyBase64Url } = await encryptText(text)
      const id = await createBurnMessage({ ciphertext, iv })
      const url =
        `${window.location.origin}/ferramentas/texto-temporario/ler` +
        `?id=${id}#${keyBase64Url}`
      setLink(url)
      setStatus('ready')
      trackEvent('tool_generate', { tool: 'burn_message' })
    } catch {
      setStatus('error')
    }
  }

  const copy = () => {
    navigator.clipboard.writeText(link)
    setCopied(true)
    trackEvent('tool_copy', { tool: 'burn_message' })
    setTimeout(() => setCopied(false), 1500)
  }

  const reset = () => {
    setText('')
    setLink('')
    setStatus('idle')
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Texto Temporário (lido uma única vez)</h1>
      <p className="tool-disclaimer">
        O texto é criptografado no seu navegador antes de ser enviado  a
        chave de decifragem vai só no link, nunca é armazenada em
        servidor nenhum. Assim que alguém abrir e revelar o link, a
        mensagem é apagada para sempre  nem você vai conseguir abri-la
        de novo.
      </p>

      {status !== 'ready' && (
        <>
          <div className="tool-field">
            <label htmlFor="secret-text">Sua mensagem</label>
            <textarea
              id="secret-text"
              rows="8"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Cole aqui uma senha, um recado ou qualquer texto sensível..."
            />
          </div>
          <button
            type="button"
            className="tool-button"
            onClick={generate}
            disabled={!text.trim() || status === 'loading'}
          >
            {status === 'loading' ? 'Gerando link...' : 'Gerar link'}
          </button>
          {status === 'error' && (
            <p className="tool-error">
              Não foi possível gerar o link agora. Tente novamente.
            </p>
          )}
        </>
      )}

      {status === 'ready' && (
        <div className="tool-result-card" style={{ flexDirection: 'column', alignItems: 'stretch' }}>
          <span className="tool-result-label">
            Seu link (funciona uma única vez)
          </span>
          <span className="tool-result-value" style={{ wordBreak: 'break-all' }}>
            {link}
          </span>
          <div className="tool-result-actions">
            <button
              type="button"
              className="tool-button tool-button-secondary"
              onClick={copy}
            >
              Copiar link
            </button>
            <button type="button" className="tool-button" onClick={reset}>
              Criar outro
            </button>
          </div>
          {copied && <span className="tool-copied">Copiado!</span>}
        </div>
      )}

      <div className="tool-info-section">
        <h2>Como funciona a criptografia</h2>
        <p>
          O texto é criptografado no seu navegador com AES-GCM antes de
          sair da sua máquina  o servidor só recebe e guarda o conteúdo
          já cifrado. A chave de decifragem vai embutida depois do{' '}
          <code>#</code> no link, uma parte da URL que os navegadores
          nunca enviam ao servidor. Ou seja, quem hospeda o site não
          consegue ler a mensagem em nenhum momento.
        </p>
        <p>
          Assim que o destinatário abre o link e revela o texto, a
          mensagem cifrada é apagada do servidor. Se alguém tentar abrir
          o mesmo link de novo (inclusive você), só vai ver que ele já
          foi lido. Ideal para compartilhar senhas, chaves de API ou
          qualquer informação sensível uma única vez.
        </p>
      </div>
    </div>
  )
}

export default BurnMessageCreate
